import { Link } from 'react-router-dom';

import { GFE_DISCLAIMER_URL } from 'lib/constants/billing/data';

import QrCode from 'components/shared/QrCode/QrCode';
import Typography from 'components/shared/Typography/Typography';

const DISCLOSURES = [
  'This is a Good Faith Estimate (GFE), not a bill. Final charges may vary.',
  `If you're uninsured or self-pay, you may dispute charges $400+ over this estimate at www.cms.gov/nosurprises or 1-800-985-3059.`
];

const RequiredDisclosures = () => {
  return (
    <div className="sticky bottom-0 mt-auto flex gap-4 border-0 border-t border-solid border-t-neutral-200 bg-white px-4 py-3 shadow-[0px_-1px_4px_rgba(65,70,81,0.1)]">
      <div className="flex flex-col gap-2 w-full">
        <div className="flex flex-col gap-0.5">
          <Typography variant="p" size="xs" weight="medium">
            Required Disclosures & Patient Rights
          </Typography>
          <ol className="m-0 list-none p-0 text-left">
            {DISCLOSURES.map((text) => (
              <li
                key={text}
                className="whitespace-pre-line break-words text-xs font-normal leading-5 text-neutral-900 before:mr-0.5 before:content-['•']">
                {text}
              </li>
            ))}
          </ol>
        </div>
        <div className="flex flex-col rounded w-full bg-white">
          <div className="flex h-14 w-full justify-between gap-1 bg-primary-100 px-3 py-2">
            <Typography variant="p" size="xs" weight="medium">
              Tap QR code to download mandatory CMS GFE Disclaimer.
            </Typography>
            <Link to={GFE_DISCLAIMER_URL} target="_blank" rel="noopener noreferrer">
              <QrCode
                value={GFE_DISCLAIMER_URL}
                size={40}
                bgColor="#00000000"
                hoverColor="#0BA5EC"
                clickColor="#0086C9"
                className="flex-shrink-0"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequiredDisclosures;
